module.exports = __webpack_public_path__ + "static/img/UBC教室_1.c1a266a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UBC/UBC教室_1.png
// module id = ke/o
// module chunks = 0